import styled from "styled-components/macro";
import { mediaMin } from "styles/media";

export const SectionTitle = styled.h2`
  margin: 0;
  font-size: 24px;
  line-height: 120%;
  font-weight: 500;

  ${mediaMin.xs`
    font-size: 32px;
  `};
  ${mediaMin.md`
    font-size: 36px;
  `};
`;

export const SectionSubTitle = styled.h3`
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.gray300};
  line-height: 120%;

  ${mediaMin.xs`
    font-size: 16px;
    font-weight: 400;
  `};

  ${mediaMin.md`
    font-size: 22px;
  `};
`;

export const SectionDescription = styled.p`
  margin: 0;
  font-size: 15px;
  line-height: 140%;
  ${mediaMin.md`
    font-size: 18px;
    line-height: 150%;
  `};
`;

export const DescriptionTitle = styled.h4`
  margin: 0 0 16px 0;
  font-size: 18px;
  line-height: 120%;
  font-weight: 500;

  ${mediaMin.xs`
    font-size: 24px;
  `};
  ${mediaMin.lg`
    margin: 0 0 24px 0;
  `};
`;

export const DescriptionContent = styled.p`
  margin: 0;
  font-size: 15px;
  line-height: 140%;
  ${mediaMin.md`
    font-size: 18px;
    line-height: 150%;
  `};
`;

export const TitleArea = styled.div`
  grid-area: title-area;
`;

export const DescriptionArea = styled.div`
  grid-area: desc-area;
  white-space: pre-line;
`;

export const AssetArea = styled.div`
  grid-area: image-area;
  display: flex;
  justify-content: center;
`;

export const Image = styled.img`
  width: 100%;
  object-fit: contain;
  max-width: 900px;
`;

export const Video = styled.video`
  width: 100%;
  max-width: 900px;
  border-radius: 12px;
`;

export const DescriptionArea1 = styled.div`
  grid-area: desc-area-1;
  white-space: pre-line;
`;

export const DescriptionArea2 = styled.div`
  grid-area: desc-area-2;
  white-space: pre-line;
`;

export const DescriptionArea3 = styled.div`
  grid-area: desc-area-3;
  white-space: pre-line;
`;

export const GridLayout = styled.div`
  display: grid;
  column-gap: 16px;
`;
